export const COOKIE_EXPIRE_DAYS = 7 * 24 * 60 * 60 * 1000; // 쿠키 만료 기간 (7일)
export function setCookie(name, value, times = COOKIE_EXPIRE_DAYS) {
    const date = new Date();
    date.setTime(date.getTime() + times);
    const expires = `; expires=${date.toUTCString()}`;
    const serialized = Array.isArray(value) ? JSON.stringify(value) : value;
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(serialized)}${expires}; path=/`;
}
